@if (bar.config().label || (bar.config().tabs && bar.config().tabs!.length) || bar.config().backLabel || bar.config().actionsTemplate) {
<div class="page-bar" [class.page-bar--mobile]="device.isMobile()">

  <!-- ══ BANDE 1 — mobile uniquement : ‹ Liste  +  label ══════════════════ -->
  @if (device.isMobile()) {
    <div class="page-bar__mobile-header">
      @if (bar.config().backLabel) {
        <button class="page-bar__back-btn" (click)="onBack()">
          <img src="assets/icon/new_icon/arrow-left.svg" alt="Scroll left">
          {{ bar.config().backLabel | translate }}
        </button>
      }
      @if (bar.config().label) {
        <span class="page-bar__label">{{ bar.config().label }}</span>
      }
    </div>
  }

  <!-- ══ BANDE TABS ════════════════════════════════════════════════════════ -->
  <div class="page-bar__tabs-row">

    <!-- Label + séparateur — desktop uniquement -->
    @if (device.isDesktop() && bar.config().label) {
      <span class="page-bar__label">{{ bar.config().label }}</span>
    }

    <!-- Bouton gauche -->
    @if (canScrollLeft() || canScrollRight()) {
      <button class="page-bar__nav-btn" (click)="scrollTabs('left')"
        [hidden]="!canScrollLeft()" [class.disabled]="!canScrollLeft()">
          <img src="assets/icon/floating.svg" alt="Scroll left" style="transform: rotate(180deg);">
      </button>
    }

    <!-- Wrapper : masque le débordement -->
    <div class="page-bar__tabs-wrapper" #tabsWrapper>

      <!-- Conteneur scrollable : uniquement les tabs -->
      <div class="page-bar__scrollable-inner" #scrollableInner>

        <!-- Tabs dans le nav — styles isolés ici -->
        <nav class="page-bar__tabs" role="tablist">
          @for (tab of bar.config().tabs ?? []; track tab.id) {
            <button class="page-bar__tab" role="tab"
              [class.page-bar__tab--active]="tab.id === bar.config().activeTabId"
              [attr.data-attr]="tab.dataAttr"
              (click)="onTab(tab)">
              {{ tab.label | translate }}
            </button>
          }
        </nav>

      </div>
    </div>

    <!-- Bouton droite -->
    @if (canScrollLeft() || canScrollRight()) {
      <button class="page-bar__nav-btn" (click)="scrollTabs('right')"
        [hidden]="!canScrollRight()" [class.disabled]="!canScrollRight()">
          <img src="assets/icon/floating.svg" alt="Scroll right">
      </button>
    }

    <!-- Actions — fixes à droite, hors de la zone scrollable -->
    @if (bar.config().actionsTemplate) {
      <div class="page-bar__actions">
        <ng-container *ngTemplateOutlet="bar.config().actionsTemplate!"></ng-container>
      </div>
    }

  </div>

</div>
}